export const CID_COOKIE = 'domGO_cid';
export const REFRESH_TOKEN_COOKIE = 'domGO_refreshTok';
export const FIREBASE_TOKEN_COOKIE = 'domGO_firebase';
export const FIREBASE_NOTIFICATION_COOKIE = 'domGO_firebaseNot';
export const OAUTH_SESSION_ID_COOKIE = 'domGO_oauthSessionId';
export const TSID_SUB_COOKIE = 'domGO_tsidSub';
export const TSID_MIGRATED_COOKIE_PREFIX = 'domGO_tsidMigrated';
